import React, { useEffect, useRef, useState } from 'react';
import FeatureDecisionModal from '../classFeatures/FeatureDecisionModal';
import { registerStrokeOfLuckPresenter } from '../utils/strokeOfLuckPrompt';

/** Shows the Stroke of Luck question that any failed save or check asks (see offerStrokeOfLuck). */
export default function StrokeOfLuckPrompt() {
  const [decision, setDecision] = useState(null);
  const answer = useRef(null);
  useEffect(() => registerStrokeOfLuckPresenter((next) => new Promise((resolve) => {
    answer.current = resolve; setDecision(next);
  })), []);
  return <FeatureDecisionModal decision={decision} onChoose={(choice) => { setDecision(null); answer.current?.(choice); answer.current = null; }} />;
}
